import KeyFeaturesHeading from './KeyFeaturesHeading'

export default KeyFeaturesHeading
